var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table", { staticClass: "table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.items, function (row, index) {
            return _c(
              "tr",
              {
                key: index,
                staticClass: "border-bottom border-left border-right",
              },
              [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      style: {
                        pointerEvents: row.button_course_status
                          ? "auto"
                          : "none",
                      },
                      attrs: { href: row.course_url },
                    },
                    [_vm._v(_vm._s(row.name))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-nowrap" }, [
                  _vm._v(_vm._s(row.education_type)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-nowrap" }, [
                  _vm._v(_vm._s(row.date_start) + " - " + _vm._s(row.date_end)),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(row.status))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    {
                      staticClass: "rounded",
                      staticStyle: { background: "rgb(0,108,255)" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-center rounded white font-weight-bold",
                          style: {
                            background:
                              "linear-gradient(90deg, rgba(0,108,255,1)" +
                              row.progress_slides +
                              "%, rgba(157,157,157,1) 0%)",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(row.progress_slides) +
                              "%\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  row.has_test
                    ? _c(
                        "div",
                        {
                          staticClass: "rounded",
                          staticStyle: { background: "rgb(0,108,255)" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center rounded white font-weight-bold",
                              style: {
                                background:
                                  "linear-gradient(90deg, rgba(0,108,255,1)" +
                                  row.progress_tests +
                                  "%, rgba(157,157,157,1) 0%)",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.progress_tests) +
                                  "%\n            "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c("div", { staticStyle: { "text-align": "center" } }, [
                        _c(
                          "svg",
                          {
                            staticClass: "size-6",
                            staticStyle: {
                              margin: "0 auto",
                              width: "2rem",
                              height: "2rem",
                            },
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
                              },
                            }),
                          ]
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: row.button_course_status ? row.course_url : "",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { disabled: !row.button_course_status },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(row.button_course_text) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      class: [
                        "btn",
                        row.exam_limit ? "btn-warning" : "btn-secondary",
                      ],
                      attrs: {
                        disabled: !row.button_exam_status,
                        title: row.exam_limit
                          ? "Экзамен станет доступен " + row.current_day
                          : "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.examButtonHandler(row)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(row.button_exam_text) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showPracticeModal
        ? _c("practice-required-modal", {
            attrs: { "practice-sheet-url": _vm.practiceSheetUrl },
            on: {
              close: function ($event) {
                _vm.showPracticeModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRemotePracticeModal
        ? _c("remote-practice-modal", {
            attrs: {
              "sheet-url": _vm.remotePractice.sheetUrl,
              "sign-url": _vm.remotePractice.signUrl,
              "upload-url": _vm.remotePractice.uploadUrl,
              "pep-allowed": _vm.remotePractice.pepAllowed,
            },
            on: {
              passed: _vm.onRemotePracticePassed,
              close: function ($event) {
                _vm.showRemotePracticeModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPinModal
        ? _c("div", { staticClass: "modal" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h3", [_vm._v("Введите пин-код куратора")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.enteredPinCode,
                    expression: "enteredPinCode",
                  },
                ],
                attrs: { type: "password", placeholder: "Пин-код" },
                domProps: { value: _vm.enteredPinCode },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.verifyPinCode($event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.enteredPinCode = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-modal",
                  attrs: { type: "button" },
                  on: { click: _vm.verifyPinCode },
                },
                [_vm._v("Проверить")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-modal",
                  on: { click: _vm.closeModal },
                },
                [_vm._v("Отмена")]
              ),
              _vm._v(" "),
              _vm.pinError
                ? _c("p", { staticClass: "error" }, [
                    _vm._v("Неверный пин-код, попробуйте еще раз."),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("№")]),
        _vm._v(" "),
        _c("th", [_vm._v("Название курса")]),
        _vm._v(" "),
        _c("th", [_vm._v("Вид обучения")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Период")]),
        _vm._v(" "),
        _c("th", [_vm._v("Статус")]),
        _vm._v(" "),
        _c("th", { staticClass: "progress-column text-center" }, [
          _vm._v("Обучение"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "progress-column text-center" }, [
          _vm._v("Тестирование"),
        ]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }